var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.t)?_c('div',{staticClass:"div-cls2",on:{"click":_vm.divFun}},[_vm._v(_vm._s(_vm.newValue))]):_c('el-input',{ref:"inputRef",staticClass:"input-cls",attrs:{"value":_vm._value},on:{"blur":_vm.bindBlur,"input":_vm.bindInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }